module.exports = __webpack_public_path__ + "media/zoho/zoho_faq1-d8ef7cbb.png";